import InfoBranding from "./InfoBranding";


export default InfoBranding;